import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/FavOn.png'
import _imports_1 from '@/assets/FavOff.png'


const _withScopeId = n => (_pushScopeId("data-v-4060f326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"float":"right"} }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "icon",
  width: "20",
  height: "20"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  class: "icon",
  width: "20",
  height: "20"
}
const _hoisted_4 = { class: "athlete-favorite-club" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateFavorites && _ctx.updateFavorites(...args))),
        class: "athlete-favorite-name"
      }, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.namePrefix) + " ", 1),
          _createElementVNode("span", {
            class: _normalizeClass({
            'female ': _ctx.gender == '2',
            male: _ctx.gender == '1',
          })
          }, _toDisplayString(_ctx.lastNameFirstLetter.toUpperCase()), 3),
          _createTextVNode(_toDisplayString(_ctx.lastNameWithoutFirstLetter.toUpperCase()) + ", " + _toDisplayString(_ctx.firstName) + ", " + _toDisplayString(_ctx.get_yob_from_athlete_id(_ctx.athleteid)), 1)
        ]),
        _createElementVNode("span", _hoisted_1, [
          (_ctx.is_favorite(_ctx.athleteid))
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", null, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: {
            name: 'Club',
            params: {
              clubid: _ctx.get_club_id_from_athlete_id(String(_ctx.athleteid)),
              meetid: _ctx.$route.params.meetid,
              athleteid: 0,
              eventid: 0,
            },
          }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.get_clubname_from_club_id(_ctx.get_club_id_from_athlete_id(String(_ctx.athleteid)))), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _hoisted_5
      ])
    ])
  ], 64))
}